var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "act-login" }, [
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "state" },
        [
          _c("img", { attrs: { src: require("./imgs/success.png"), alt: "" } }),
          _vm._m(0),
          _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.phone))]),
          _c("p", { staticClass: "info" }, [
            _vm._v(" 现金红包已发放,"),
            _c(
              "span",
              { staticClass: "color-text", on: { click: _vm.downloadApp } },
              [_vm._v("下载APP完成认证")]
            ),
            _vm._v("就能领取啦 ")
          ]),
          _c("div", { staticClass: "line" }),
          _c("notice", { staticClass: "notice" }),
          _c("div", { staticClass: "button-wrp" }, [
            _c("div", { staticClass: "btn", on: { click: _vm.downloadApp } }, [
              _vm._v("下载APP")
            ])
          ]),
          _vm._m(1),
          _vm._m(2),
          _c("p", { staticClass: "footer-text" }, [
            _vm._v("海量案源，尽在长律")
          ])
        ],
        1
      )
    ]),
    _c("img", {
      staticClass: "bg",
      attrs: { src: require("./imgs/login-bg.png"), alt: "" }
    }),
    _c("div", { ref: "wxmask", staticClass: "wx-mask" }, [
      _c("img", { attrs: { src: require("./imgs/what_tip1.png"), alt: "" } })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("span", { staticClass: "font16" }, [_vm._v("成功!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "extra-info" }, [
      _c("div", { staticClass: "ifo" }, [
        _vm._v("您也可至应用商店搜索“长律”进行下载哦")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", { attrs: { src: require("./imgs/logo.png"), alt: "" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }